<template>
	<v-form ref="form">
		<v-row dense>
			<v-col cols="12">
				<v-text-field
					label="Реєстраційний номер"
					v-model.trim="item.number"
					outlined
					dense
					clearable
					@keyup.ctrl.90="$set(item,'number','AB9999IT')"
					hide-details="auto"
					append-outer-icon="mdi-car-search"
					@click:append-outer="identification(item.number)"
				></v-text-field>
			</v-col>
			<v-col cols="12">
				<v-text-field
					label="VIN-код"
					v-model.trim="item.vin"
					outlined
					dense
					clearable
					@keyup.ctrl.90="$set(item,'vin','WAUZZZ4M0HD001505')"
					hide-details="auto"
					append-outer-icon="mdi-car-search"
					@click:append-outer="identification(item.vin)"
				></v-text-field>
			</v-col>
			<v-col cols="12">
				<v-combobox
					v-model="item.category"
					:items="categories"
					label="Категорія"
					outlined
					dense
					item-text="name"
					item-value="id"
					hide-details="auto"
					:loading="loading.category"
					:rules="[rules.onlyFromList]"
					@change="onCategory"
					@focus="loadCategories"
				></v-combobox>
			</v-col>
			<v-col cols="12">
				<v-combobox
					v-model="item.brand"
					:items="brands"
					label="Марка"
					outlined
					dense
					item-text="name"
					item-value="id"
					hide-details="auto"
					:loading="loading.brand"
					:rules="[rules.onlyFromList]"
					@change="onBrand"
					@focus="loadBrands"
				></v-combobox>
			</v-col>
			<v-col cols="12">
				<v-combobox
					v-model="item.model"
					:items="models"
					label="Модель"
					outlined
					dense
					item-text="name"
					item-value="id"
					hide-details="auto"
					:loading="loading.model"
					:rules="[rules.onlyFromList]"
					@change="onModel"
					@focus="loadModels"
				></v-combobox>
			</v-col>
			<v-col cols="12">
				<v-combobox
					v-model="item.generation"
					:items="generations"
					label="Покоління"
					outlined
					dense
					item-text="name"
					item-value="id"
					hide-details="auto"
					:loading="loading.generation"
					@change="onGeneration"
					@focus="loadGenerations"
				>
					<template v-slot:item="{ on, item }">
						<v-list-item v-on="on">
							<v-list-item-content>
								<v-list-item-title>{{ item.name }}</v-list-item-title>
								<v-list-item-subtitle>{{ item.yearFrom }} - {{ item.yearTo }}</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>
					</template>
				</v-combobox>
			</v-col>
			<v-col cols="12">
				<v-combobox
					v-model="item.modification"
					:items="modifications"
					label="Модифікація"
					outlined
					dense
					item-text="name"
					item-value="id"
					hide-details="auto"
					:loading="loading.modification"
					@focus="loadModifications"
				></v-combobox>
			</v-col>
			<v-col cols="12">
				<v-combobox
					v-model="item.yearProd"
					:items="years"
					label="Рік випуску"
					outlined
					dense
					hide-details="auto"
					:loading="loading.yearProd"
					
					@focus="loadYearProds"
				></v-combobox>
				<!-- :rules="[rules.required]" -->
			</v-col>
			<v-col cols="12">
				<v-combobox
					v-model="item.driver"
					:items="drivers"
					label="Тип приводу"
					outlined
					dense
					item-text="name"
					item-value="id"
					hide-details="auto"
					:loading="loading.driver"
					@focus="loadDrivers"
				></v-combobox>
			</v-col>
			<v-col cols="12">
				<v-text-field
					v-model="item.engineVolume"
					label="Об'єм двигуна, л."
					outlined
					dense
					type="number"
					hide-details="auto"
					:min="0"
					:max="10"
				></v-text-field>
			</v-col>
			<v-col cols="12">
				<v-combobox
					v-model="item.fuel"
					:items="fuels"
					label="Тип палива"
					outlined
					dense
					item-text="name"
					item-value="id"
					hide-details="auto"
					:loading="loading.fuel"
					@focus="loadFuels"
				></v-combobox>
			</v-col>
			<v-col cols="12">
				<v-combobox
					v-model="item.gearbox"
					:items="gearboxes"
					label="Коробка передач"
					outlined
					dense
					item-text="name"
					item-value="id"
					hide-details="auto"
					:loading="loading.gearbox"
					@focus="loadGearboxes"
				></v-combobox>
			</v-col>
			<v-col cols="12">
				<v-combobox
					v-model="item.color"
					:items="colors"
					label="Колір"
					outlined
					dense
					item-text="name"
					item-value="id"
					hide-details="auto"
					:loading="loading.color"
					@focus="loadColors"
				></v-combobox>
			</v-col>
			<v-col cols="12">
				<v-text-field
					v-model="item.odometer"
					label="Показник одометра, км"
					outlined
					dense
					type="number"
					hide-details="auto"
					min="0"
				></v-text-field>
			</v-col>
			<v-col cols="12">
				<v-textarea
					v-model="item.description"
					label="Коментар"
					outlined
					dense
					hide-details="auto"
					rows="2"
				></v-textarea>
			</v-col>
			<!-- <v-col cols="12">
				<v-combobox
					v-model="item.damage"
					:items="damages"
					label="ДТП"
					outlined
					dense
					item-text="name"
					item-value="value"
					hide-details="auto"
				></v-combobox>
			</v-col>
			<v-col cols="12">
				<v-combobox
					v-model="item.period"
					:items="periods"
					label="Період оцінки"
					outlined
					dense
					item-text="name"
					item-value="value"
					hide-details="auto"
				></v-combobox>
			</v-col> -->
		</v-row>
	</v-form>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
//import mixin from './mixin/parameters'

export default {
	name: 'vehicle.parameters.park',
	//mixins: [mixin],

	data () {
		return {
			minYear: 1900,
			maxYear: (new Date()).getFullYear(),
			minMileage: 1,
			maxMileage: 1000,
			minEngineVolume: 0,
			maxEngineVolume: 10,

			damages: [
				{ id: 1, name: 'Всі', value: null},
				{ id: 2, name: 'Без ДТП', value: 0},
				{ id: 3, name: 'Після ДТП', value: 1},
			],

			periods: [
				{ name: 'Останній місяць', value: '30'},
				{ name: '3 місяці', value: '90'},
				{ name: 'Останні півроку', value: '180'},
				{ name: 'Останній рік', value: '365'},
			],

			loading: {
				category: false,
				brand: false,
				model: false,
				generation: false,
				modification: false,
				yearProd: false,
				driver: false,
				option: false,
				fuel: false,
				gearbox: false,
				color: false,
				country: false,
				state: false,
				city: false,
			},

			rules: {
				required: (value) => !!value || "Обов'язкове для заповнення",
				//onlyFromList: (v) => (!!v && v?.id > 0 ) || "Необхідно обрати значення зі списку",
				onlyFromList: (v) => !v || v?.id > 0 || "Необхідно обрати значення зі списку",
			},
		}
	},
	props: {
		value: 		{ type: Object, default: () => {} },
		//module:			{ type: String, default: 'VehicleEstimate'}, // check | market | metodica | exploration | averageprice
	},

	computed: {
		...mapGetters([
			'roles',
			'categories', 'fuels', 'colors', 'countries', 'states'
		]),
		...mapGetters('VehicleEstimate',[
			'brands', 'models', 'generations', 'modifications', 'bodystyles', 'drivers', 'gearboxes', 'options', 'cities'
		]),

		/* ...mapGetters('VehicleCategory', { categories: 'items' }),
		...mapGetters('VehicleBrand', { brands: 'items' }),
		...mapGetters('VehicleBrandModel', { models: 'items' }),
		...mapGetters('VehicleGeneration', { generations: 'items' }),
		...mapGetters('VehicleModification', { modifications: 'items' }),
		...mapGetters('VehicleBodystyle', { bodystyles: 'items' }),
		...mapGetters('VehicleDriver', { drivers: 'items' }),
		...mapGetters('VehicleGearbox', { gearboxes: 'items' }),
		...mapGetters('VehicleFuel', { fuels: 'items' }),
		...mapGetters('VehicleColor', { colors: 'items' }), */

		...mapGetters('app', ['profile']),

		item: {
			get() 		{ return this.value },
			set(val) 	{ this.$emit('input', val) }
		},

		years() {
			const arrayRange = (start, stop, step) =>
			Array.from(
				{ length: (stop - start) / step + 1 },
				(value, index) => start + index * step
			);
			return arrayRange(this.minYear, this.maxYear, 1).reverse();
		},

		visibleDeleteModel() {
			//console.log(this.$options.name, 'visibleDeleteModel', 'holder', this.holder)
			//return this.holder?.roles ? this.holder.roles.includes('ADMIN') : false
			return this.roles.includes('ADMIN')
		},
		
		/* modelRules() {
			return this.roles.includes('ADMIN') ? [] : [this.rules.required, this.rules.onlyFromList]
		}, */
	},

	watch: {
		/* 'item.brand': function (val) {
			if(val) {
				this.Models({brand: val.id})
			}
		}, */
		/* item: function (val) {
			if(val) {
				console.log('vehicle.estimate.detail', 'watch', 'item', val)
			}
		}, */
	},

	created () {
		//console.log(this.$options.name, 'created')
		//this.item.year 			= [this.minYear, this.maxYear]
		//this.item.mileage		= [this.minMileage, this.maxMileage]
		//this.item.engineVolume	= [this.minEngineVolume, this.maxEngineVolume]
		//this.item.period		= 365

		this.item.damage = this.damages[0];
		this.item.period = this.periods[3];
	},
	
	methods: {
		/* ...mapActions('VehicleCategory', { loadCategory: 'load'}),
		...mapActions('VehicleBrand', { loadBrand: 'load', setBrands: 'setItems' }),
		...mapActions('VehicleBrandModel', { loadModel: 'load', setModels: 'setItems' }),
		...mapActions('VehicleGeneration', { loadGeneration: 'load', setModels: 'setItems' }),
		...mapActions('VehicleModification', { loadModification: 'load', setModels: 'setItems' }),
		...mapActions('VehicleBodystyle', { loadBodystyle: 'load', setModels: 'setItems' }),
		...mapActions('VehicleDriver', { loadDriver: 'load', setModels: 'setItems' }),
		...mapActions('VehicleGearbox', { loadGearbox: 'load', setModels: 'setItems' }),
		...mapActions('VehicleFuel', { loadFuel: 'load', setFuels: 'setItems' }),
		...mapActions('VehicleColor', { loadColor: 'load', setColors: 'setItems' }), */

		...mapActions([
			'setCategories', 'setFuels', 'setColors', 'setCountries', 'setStates'
		]),

		...mapActions('VehicleEstimate', [
			'setBrands', 'setModels', 'setGenerations', 'setModifications', 'setBodystyles', 'setDrivers',
			'setGearboxes','setOptions','setCities',
		]),

		reset() {
			this.$refs.form.reset()
		},

		validate() {
			return this.$refs.form.validate()
		},

		clearBrand () {
			this.$set(this.item, 'brand', null)
			this.setBrands()

			this.clearModel()
		},

		clearModel () {
			this.$set(this.item, 'model', null)
			this.setModels()
			
			this.clearGeneration()
		},

		clearGeneration () {
			this.$set(this.item, 'generation', null)
			this.setGenerations()
			
			this.clearModification()
		},

		clearYearProd() {
			this.$set(this.item, 'yearProd', null)
			this.minYear = 1900
			this.maxYear = (new Date()).getFullYear()
		},

		clearModification () {
			this.$set(this.item, 'modification', null)
			this.setModifications()
		},

		clearBodystyle () {
			this.$set(this.item, 'bodystyle', null)
			this.setBodystyles()
		},

		clearDriver () {
			this.$set(this.item, 'driver', null)
			this.setDrivers()
		},

		clearGearbox () {
			this.$set(this.item, 'gearbox', null)
			this.setGearboxes()
		},

		clearOption () {
			this.$set(this.item, 'option', null)
			this.setOptions()
		},

		clearCity () {
			this.$set(this.item, 'city', null)
			this.setCities()
		},

		// Завантаження категорій
		loadCategories(e) {
			if(this.categories.length == 0) {
				this.loading.category = true
				var that = this
				axios.get('/vehicle/category').then(response => {
					that.setCategories(response.data.filter((element) => ['CAR','TRUCK'].includes(element.code)))
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.category = false));
			}
		},

		// Завантаження брендів
		loadBrands() {
			//if(this.item?.category?.id && this.brands.length == 0) {
			if(this.item?.category?.id) {
				this.loading.brand = true
				var that = this
				axios.get(`/vehicle/category/${this.item.category.id}/brand`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.setBrands(response.data)
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.brand = false));
			}
		},

		// Завантаження моделей
		loadModels() {
			//if(this.item?.category?.id && this.item?.brand?.id && this.models.length == 0) {
			if(this.item?.category?.id && this.item?.brand?.id) {
				this.loading.model = true
				var that = this
				axios.get(`/vehicle/category/${this.item.category.id}/brand/${this.item.brand.id}/models`).then(response => {
					//console.log(that.$options.name, 'GetdModels','response.data', response.data)
					that.setModels(response.data)
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.model = false));
			}
		},

		// Завантаження поколінь
		loadGenerations() {
			//if(this.item?.model?.id && this.generations.length == 0) {
			if(this.item?.model?.id) {
				this.loading.generation = true
				var that = this
				axios.get(`/vehicle/model/${this.item.model.id}/generation`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.setGenerations(response.data)
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.generation = false));
			}
		},

		// Завантаження років виробництва
		loadYearProds() {
			//console.log(this.$options.name, 'loadYearProds','generation', this.item.generation)

			this.minYear = this.item?.generation?.yearFrom ? this.item.generation.yearFrom : 1900
			this.maxYear = this.item?.generation?.yearTo ? this.item.generation.yearTo : (new Date()).getFullYear()
		},

		// Завантаження модифікацій
		loadModifications() {
			//if(this.item?.generation?.id && this.modifications.length == 0) {
			if(this.item?.generation?.id) {
				this.loading.modification = true
				var that = this
				axios.get(`/vehicle/generation/${this.item.generation.id}/modification`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.setModifications(response.data)
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.modification = false));
			}
		},

		// Завантаження типів кузова
		loadBodystyles() {
			if(this.item?.category?.id && this.bodystyles.length == 0) {
				this.loading.bodystyle = true
				var that = this
				axios.get(`/vehicle/category/${this.item.category.id}/bodystyle`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.setBodystyles(response.data)
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.bodystyle = false));
			}
		},

		// Завантаження типів приводу
		loadDrivers() {
			if(this.item?.category?.id && this.drivers.length == 0) {
				this.loading.driver = true
				var that = this
				axios.get(`/vehicle/category/${this.item.category.id}/driver`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.setDrivers(response.data)
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.driver = false));
			}
		},

		// Завантаження типів коробок передач
		loadGearboxes() {
			if(this.item?.category?.id && this.gearboxes.length == 0) {
				this.loading.gearbox = true
				var that = this
				axios.get(`/vehicle/category/${this.item.category.id}/gearbox`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.setGearboxes(response.data)
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.gearbox = false));
			}
		},

		// Завантаження опцій
		loadOptions() {
			if(this.item?.category?.id && this.options.length == 0) {
				this.loading.option = true
				var that = this
				axios.get(`/vehicle/category/${this.item.category.id}/option`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.setOptions(response.data)
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.option = false));
			}
		},

		// Завантаження типів палива
		loadFuels() {
			if(this.fuels.length == 0) {
				this.loading.fuel = true
				var that = this
				axios.get('/vehicle/fuel').then(response => {
					//console.log(that.$options.name, 'created','response.data', response.data)
					that.setFuels(response.data)
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.fuel = false));
			}
		},

		// Завантаження кольорів
		loadColors() {
			if(this.colors.length == 0) {
				this.loading.color = true
				var that = this
				axios.get('/vehicle/color').then(response => {
					//console.log(that.$options.name, 'created','response.data', response.data)
					that.setColors(response.data)
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.color = false));
			}
		},

		// Завантаження країн виробників
		loadCountries() {
			if(this.countries.length == 0) {
				this.loading.country = true
				var that = this
				axios.get('/vehicle/country').then(response => {
					//console.log(that.$options.name, 'created','response.data', response.data)
					that.setCountries(response.data)
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.country = false));
			}
		},

		// Завантаження областей
		loadStates() {
			if(this.states.length == 0) {
				this.loading.state = true
				var that = this
				axios.get('/state').then(response => {
					//console.log(that.$options.name, 'created','response.data', response.data)
					that.setStates(response.data)
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.state = false));
			}
		},

		// Завантаження міст
		loadCities() {
			if(this.item?.state?.id && this.states.length == 0) {
				this.loading.city = true
				var that = this
				axios.get(`/state/${this.item.state.id}/city`).then(response => {
					//console.log(that.$options.name, 'created','response.data', response.data)
					that.setCities(response.data)
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.city = false));
			}
		},

		onCategory (item) {
			this.clearBrand()
			this.clearBodystyle()
			this.clearDriver()
			this.clearGearbox()
			this.clearOption()
		},

		onBrand (item) {
			this.clearModel()
		},

		onModel (item) {
			this.clearGeneration()
		},

		onGeneration (item) {
			this.clearYearProd()
			this.clearModification()
		},

		onState (item) {
			this.clearCity()
		},

		onDeleteModel (item) {
			//console.log(that.$options.name, 'onDeleteModel', 'item', item)
			//console.log(that.$options.name, 'onDeleteModel', 'profile', this.profile)

			if(item?.id) {
				var that = this
				axios.put(`/vehicle/models/${item.id}/datedelete`).then(response => {
					//console.log(that.$options.name, 'onDelete','response.data', response.data)
					const index = that.models.indexOf(item)
					that.models.splice(index, 1);
					that.item.model = null
				}, error => {
					console.log('error', error)
				});
			}
		},

		onUpgrateModel() {
			if(this.item?.category?.id && this.item?.brand?.id) {
				//console.log(this.$options.name, 'onUpgrateModel', 'category', this.item.category.id, 'brand', this.item.brand.id)

				var that = this
				axios.post(`/vehicle/category/${this.item.category.id}/brand/${this.item.brand.id}/models/upgrate`).then(response => {
					//console.log(that.$options.name, 'onUpgrateModel','response.data', response.data)
					that.setModels(response.data)
				}, error => {
					console.log('error', error)
				});
			}
		},

		/**
		 * Ідентифікація ТЗ за номером або vin-кодом
		 * 
		 * @param item 
		 */
		identification(vinnumber) {
			if(vinnumber) {
				axios.get(`/vehicle/identification/${vinnumber}`).then(response => {
					//console.log(this.$options.name, 'identification','response.data', response.data)
	
					if(response.data?.favorit) {
						if(response.data?.favorit?.number) this.item.number = response.data.favorit.number;
						if(response.data?.favorit?.vin) this.item.vin = response.data.favorit.vin;
						if(response.data?.favorit?.brand) this.item.brand = response.data.favorit.brand;
						if(response.data?.favorit?.model) this.item.model = response.data.favorit.model;
						if(response.data?.favorit?.yearProd) this.item.yearProd = response.data.favorit.yearProd;
						if(response.data?.favorit?.color) this.item.color = response.data.favorit.color;
						if(response.data?.favorit?.fuel) this.item.fuel = response.data.favorit.fuel;
						if(response.data?.favorit?.engineVolume) this.item.engineVolume = response.data.favorit.engineVolume;
					}
				}, error => {
					console.log(error)
				}).finally(() => { this.loading = false });
			}
		},
	},
}
</script>